<template>
  <div>
    <TableList
      ref="table"
      :cols="cols"
      :list="list"
      :height="tableHeight"
      :rowHeight="100"
      :selection="selection"
      @selection-change="handleSelectionChange"
    >
       <template slot="imageSlot" slot-scope="{ row }">
        <div style="display: flex; align-items: center">
          <el-popover placement="right-start" title="" trigger="hover">
            <div style="width: 250px; height: 250px">
              <el-image
                :src="`${row.image}`"
                style="width: 100%; height: 100%"
              >
                <el-image
                  slot="error"
                  :src="no_pic"
                  style="width: 100%; height: 100%"
                ></el-image>
              </el-image>
            </div>
            <el-image
              slot="reference"
              :src="`${row.image}`"
              style="width: 60px; height: 60px; margin-top: 5px"
            >
              <el-image
                slot="error"
                :src="no_pic"
                style="width: 60px; height: 60px; margin-top: 5px"
              ></el-image>
            </el-image>
          </el-popover>
        </div>
      </template>
      <template slot="urlSlot" slot-scope="{row}">
        <el-link v-if="row.url" :href="row.url" target="_blank">查看</el-link>
        <template v-if="row.extendVal1">
          <div v-if="isJSON(row)">
            <div v-if="row.extendVal1">药品ID：{{row.extendVal1?JSON.parse(row.extendVal1).app_medicine_code:''}}</div>
            <div v-if="row.extendVal1">药品UPC码：{{row.extendVal1?JSON.parse(row.extendVal1).upc:''}}</div>
          </div>
        </template>
      </template>
      <template slot="titleSlot"  slot-scope="{row}">
        <el-tooltip effect="dark" :content="row.title" placement="top">
          <span class="line-ellipsis">{{ row.title }}</span>
        </el-tooltip>
      </template>
      <template slot="statusSlot" slot-scope="{row}">
        <span>{{ getStatusText(row.status) }}</span>
        <el-link v-if="row.status == 3" @click="imageCheckDetail(row)"> 详情</el-link>
      </template>
      <template slot="scmPublishVideoLogListSlot" slot-scope="{row}">
        <div style="display:flex;flex-wrap:wrap;margin-top: 10px;max-width: 200px;min-width: 180px;">
          <span v-for="(item,index) in row.scmPublishVideoLogList"  :key="index">
            <VideoUpload :videoStyle="videoStyle" :isListVideo='true' :video="item"/>
            <el-tooltip class="item" effect="dark" :content="item.videoMessage" placement="left-start">
              <div class="video-message">{{item.videoMessage}}</div>
            </el-tooltip>      
          </span>
        </div>
      </template>
      <template slot="errorMessageSlot" slot-scope="{row}">
        <el-tooltip popper-width="400px" class="item" effect="dark" :content="row.errorMessage" placement="top">
          <span class="line-ellipsis">{{row.errorMessage}}</span>
          <span v-if="row.taskCenterId && row.publishType == 5">【裂变商品铺货，请前往 任务中心 查看详情】</span>
        </el-tooltip>
      </template>
      <template slot="opcolsSlot" slot-scope="{ row }">
        <el-button v-if="[-2, 3].includes(row.status) && ifUseTaskScheduling" type="link" @click="stopPublish(row)"> 终止铺货 </el-button>
        <el-button v-if="(!$fromGyl || ($fromGyl && row.publishEntrance) && ![ -1, 3 ].includes(row.status))" type="link" @click="rePublish(row)" :disabled="row.status == -1 || row.status == 3">重新铺货</el-button>
      </template>
    </TableList>
    <CheckImagesDialog ref="checkImagesDialogRef" />
    <!-- 商品资料编辑 -->
    <EditDialog ref="editDialog" :isFromLog="true" />
  </div>
</template>

<script>
import TableList from "@/components/TableList.vue";
import CheckImagesDialog from "./CheckImagesDialog.vue"
import tableMixins from '@mixins/table-mixins';
import no_pic from "@/assets/images/no_pic.png";
import { mapGetters, mapActions, mapMutations } from 'vuex'
import VideoUpload from '@/components/Uploads/videoUploadWithTagType.vue'
import { prodDetailByBaseItemIds, prodGetWarning , prodDisplayGoodsList} from "@/servers/prod/center";
import { getTaskCenterDataApi,editTaskCenterApi } from '@/servers/prod/taskCenter.js'
import { getCheckImagesDetail } from '@servers/prod/log/index';
import EditDialog from "@/components/prod/center/dialogs/EditDialog.vue";
import { PLATFORM_DATA_FORMAT } from '@/pages/taskCenter/config.js'

export default {
  props: {
    list: {
      type: Array,
      default() {
        return [];
      },
    },
    selection: {
      type: Boolean,
      default: false,
    },
    mode: {
      type: String,
      default: "supplier",
    },
  },
  mixins: [new tableMixins(208)],
  components: {
    TableList,
    VideoUpload,
    CheckImagesDialog,
    EditDialog
  },
  data() {
    return {
      no_pic,
      videoStyle: { width: '50px',height: '50px'},
    };
  },
  computed: {
    ...mapGetters(['routerPrefix', 'distributorDetail', 'getLogActiveName']),
    ifUseTaskScheduling() {
      return this.$store.getters?.userInfo?.ifUseTaskScheduling
    },
    cols() {
      if(this.getLogActiveName === 'publishStoresLog') {
        return [
          { prop: "image", attrs: { label: "图片", width: "90px" }, slot: true },
          { prop: "outerId", attrs: { label: "款式编码"} },
          { prop: "platformId", attrs: { label: "平台商品Id"} },
          { prop: "title", attrs: { label: "商品名称" },slot: true },
          { prop: "storeName", attrs: { label: "门店" ,minWidth:'130px',}},
          { prop: "status", attrs: { label: "状态" }, slot: true},
          { prop: "skuQuantity", attrs: { label: "SKU数量" } },
          { prop: "errorMessage", attrs: { label: "状态详情" ,}, slot: true},
        ]
      }
      return  [
        { prop: "image", attrs: { label: "图片", width: "90px" }, slot: true },
        { prop: "outerId", attrs: { label: "款式编码"} },
        { prop: "url", attrs: { label: "商品链接" }, slot: true},
        { prop: "title", attrs: { label: "商品名称" },slot: true },
        { prop: "scmPublishVideoLogList", attrs: { label: "关联视频" ,minWidth:'130px',}, slot: true},
        { prop: "status", attrs: { label: "铺货状态" }, slot: true},
        { prop: "skuQuantity", attrs: { label: "SKU数量" } },
        { prop: "errorMessage", attrs: { label: "状态详情" ,}, slot: true},
        { prop: "opcols", attrs: { label: "操作" }, slot: true }
      ]
    }
  },
  methods: {
    ...mapMutations(['setCurrentPage']),
    ...mapActions(['setRePublishRowData', 'setDisplayRePublishRowData', 'setDistributorDetail']),
    getStatusText(status) {
      const statusMap = {
        '0': '失败',
        '1': '成功',
        '-1': '执行中',
        '-2': '排队中',
        '-3': '图片上传中',
        '2': '部分sku成功',
        '3': '图片审核中',
        '4': '已终止',
        '5': '其他原因',
      }
      console.log(this.$fromGyl, '---$fromGyl--')
      return statusMap[String(status)] || ''
    },
    isJSON(row) {
      try {
        if(row.platform == 'yyjk'){
          JSON.parse(row.extendVal1);
          return true;
        } else {
           return false
        }
      } catch (e) {
        return false;
      }
    },
    // 查询店铺授权是否失效
    async fetch_getWarning(shopId) {
      const res = await prodGetWarning();
      if(!res) return;
      const warns = res.warns || [];
      const item = warns.find(item => {
        return item.id == shopId 
      })
      if(item && item.invalidSession == 1) {
        return this.$message.error('重新铺货失败：店铺授权失效，请到“店铺管理“页面重新授权； ')
      }
    },
    // 打开商品中心编辑弹窗前，先删除已存在的dom
    removeProdCenterEditDialogDom() {
      const prodCenterEditDialog = document.querySelector('#prod-center-edit-dialog')
      if (prodCenterEditDialog) {
        prodCenterEditDialog.remove()
      }
    },
   
    async rePublish(rowData) {
      await this.fetch_getWarning(rowData.shopId);
      if (!rowData.baseItemId) {
        return this.$message.error('重新铺货失败：存在商品已经被删除，请重新维护商品资料；');
      }
      // 抖音供销和抖音供销自研都用的抖音资料铺货
      rowData.platform = ['fxg_gxzy', 'fxg_gx'].includes(rowData.platform) ? 'fxg' : rowData.platform  // 抖音分校
      // 铺货入口 0-商品资料铺货  1-分销商品铺货  2-供销商展架铺货 5-店铺商品资料铺货 
      if(rowData.publishEntrance == 2){     
        const { records } = await prodDisplayGoodsList({
             companyId: rowData.extendVal2,
             distributeCompanyId: rowData.companyId,
             outerIds: rowData.outerId,
        });
        if(!(records && records.length)) return this.$message.error('重新铺货失败，该商品已被供销商设置成不可分销；');
        this.setDisplayRePublishRowData({rowData:{...records[0], 
          publishEntrance: rowData.publishEntrance, 
          publishType: rowData.publishType, 
          platform: rowData.platform,
          shopId: rowData.shopId,
          extendVal2: rowData.extendVal2,
          }
        });
        this.$router.push({
          name: `${this.routerPrefix}SupplierMineInfo`,
          query:{
            supplierId: rowData.extendVal2
          }
        })
      } else {
        // 如果是铺货,更新铺货
        if(rowData.publishType != 2){
          let res;
          let extraParams = {
              showSinglePlatformTab:true
          }
          if(rowData.publishType === 5 && rowData.taskCenterId){ // 商品裂变的日志需要取裂变的数据
            let obj = await this.getFissionData(rowData)
             extraParams.openSource = 'fissionRePublish'
             res = obj ? [obj] : null
          }else{
            res = await prodDetailByBaseItemIds({
              baseItemIds: [rowData.baseItemId]
            });
          }
          if(!res) return this.$message.error('重新铺货失败：存在商品已经被删除，请重新维护商品资料；');
          this.removeProdCenterEditDialogDom();
          let newRowData = {
            ...res[0], 
            publishEntrance: rowData.publishEntrance, 
            publishType: rowData.publishType, 
            platform: rowData.platform,
            shopId: rowData.shopId,
            errorMessage: rowData.errorMessage,
            activeName: rowData.platform, // 铺货日志进入铺货中心，需要传入平台，定位到对应平台编辑tab        
          }
          newRowData.successCallback = async (newData) => {
            if(extraParams.openSource === 'fissionRePublish'){
              await this.saveFission(rowData,newData)
            }
            this.$emit("republish", rowData);// 用于回调铺货方法
          };
          // this.setRePublishRowData({rowData:newRowData});
          if(newRowData.platform === 'ktt') {
            this.$emit("republish", rowData);// 用于回调铺货方法
            // this.$router.push({
            //   name: `${this.routerPrefix}prod_center`
            // })
          } else {
            this.$refs.editDialog.method_open(newRowData,extraParams);
          }
        } else {
          // 如果是组合铺货
            const extendVal1 = JSON.parse(rowData.extendVal1);
            const res = await prodDetailByBaseItemIds({
              baseItemIds: extendVal1
            })
            if(!res) return this.$message.error('重新铺货失败：存在商品已经被删除，请重新维护商品资料；');
            if(res.length !== extendVal1.length) return this.$message.error('重新铺货失败：存在商品已经被删除，请重新维护商品资料；');
            this.removeProdCenterEditDialogDom()
            this.setRePublishRowData({rowData});
            this.$router.push({
              name: `${this.routerPrefix}prod_center`
            })
          }

      }
    },
    stopPublish(row) {
      this.$emit('stopPublishFn', row)
    },
    async imageCheckDetail(row) {
      const list = await getCheckImagesDetail({
        companyId: this.$store.getters.userInfo.companyId,
        shopId: row.shopId,
        operationLogId: row.operationLogId,
        baseItemId: row.baseItemId,
      });
      this.$refs.checkImagesDialogRef.method_open({ list })
    },
    handleSelectionChange(selection) {
      this.$emit("selection-change", selection);
    },
    // 获取裂变商品数据
    async getFissionData(rowData){
      let platform = rowData.platform
      let res = await getTaskCenterDataApi({id:rowData.taskCenterId,companyId:rowData.companyId});
      let fissionItem = JSON.parse(res.fissionItem || null) || null
      if(PLATFORM_DATA_FORMAT[platform]){
          fissionItem = PLATFORM_DATA_FORMAT[platform](fissionItem)
      }
      return fissionItem;
    },
    //保存裂变数据
    saveFission(row,data){
        let platform = row.platform;
        let fissionItem = data;
        if(PLATFORM_DATA_FORMAT[platform]){
            fissionItem = PLATFORM_DATA_FORMAT[platform](data,true);
        }
        editTaskCenterApi({
            id:row.taskCenterId,
            companyId:row.companyId,
            fissionItem:JSON.stringify(fissionItem)
        }).then(res => {
            if(res){
                this.$message.success('保存成功！')
            }
        })
    }

  },
};
</script>

<style lang="scss" scoped>
.errorMessage{
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 3;
  -webkit-box-orient: vertical;
}
::v-deep .el-table__body-wrapper .cell {
   min-height: 100px!important;
   height: auto!important;
   max-height: 210px;
}
.video-message {
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  cursor: pointer;
  width: 56px;
}
</style>
